module.exports = __webpack_public_path__ + "static/media/about.f6c01462.png";